import { Children, Fragment, isValidElement } from 'react';
const getFragmentedChildren = (child) => {
    if (isValidElement(child) && child.type === Fragment) {
        return child.props.children;
    }
    return child;
};
export const findType = (type, children) => {
    return Children.toArray(children)
        .reduce((list, child) => list.concat(getFragmentedChildren(child)), [])
        .filter((child) => isValidElement(child) && child.type === type);
};
export const findFirstOfType = (type, children) => {
    return findType(type, children)[0] || null;
};
